real.sortable = (function($, real) {
    'use strict';

    var
        thClick,
        sortTable
    ;

    thClick = function(e) {
        var th, sortable, sortedTh, sortOrder, columnIndex;

        th = $(this);

        if(th.data('sortable') === false) {
            return;
        }

        sortable = th.closest('.real-sortable');
        sortedTh = sortable.find('thead th[data-sorted="true"]');

        if(th[0] === sortedTh[0]) {
            th.dataAndAttr('sort-order', th.data('sort-order') === 'asc' ? 'desc' : 'asc');
        } else {
            sortedTh.removeAttr('data-sorted data-sort-order');
            th.dataAndAttr('sorted', true).dataAndAttr('sort-order', 'asc');
        }

        sortOrder = th.data('sort-order');
        if(th.data('sort-reverse')) {
            sortOrder = sortOrder === 'asc' ? 'desc' : 'asc';
        }
        columnIndex = sortable.find('thead th').index(th[0]);

        sortable.trigger(real.sortable.BEFORE_SORT_TABLE);

        sortTable(sortable, sortOrder, columnIndex);

        sortable.trigger(real.sortable.TABLE_SORTED);

        return false;
    };

    sortTable = function(sortable, sortOrder, columnIndex) {
        var tbody, rows, reverse, cloneTbody;

        tbody = sortable.find('tbody')[0];

        // Slightly faster if cloned, noticable for huge tables
        rows = [].slice.call(tbody.cloneNode(true).rows, 0);

        reverse = sortOrder === 'desc';

        // Sort rows
        rows.sort(function(a, b) {
            a = a.cells[columnIndex];
            b = b.cells[columnIndex];

            a = a.dataset.value ? a.dataset.value : a.innerText;
            b = b.dataset.value ? b.dataset.value : b.innerText;

            if(reverse) {
                var c = a;
                a = b;
                b = c;
            }

            return isNaN(a - b) ? a.localeCompare(b) : a - b;
        });

        cloneTbody = tbody.cloneNode();

        rows.forEach(function(row) {
            cloneTbody.appendChild(row);
        });

        sortable[0].replaceChild(cloneTbody, tbody);
    };

    return {

        BEFORE_SORT_TABLE : 'real-sortable.before-sort-table',

        TABLE_SORTED : 'real-sortable.table-sorted',

        init : function(elem) {
            elem.findIncludingSelf('.real-sortable:not(.real-sortable-initialized)').each(function() {
                var sortable = $(this);

                sortable.addClass('real-sortable-initialized');

                sortable.find('thead th').on('click touchend', thClick);
            });
        },

        destroy : function(elem) {
            elem.findIncludingSelf('.real-sortable.real-sortable-initialized').each(function() {
                var sortable = $(this);

                sortable.removeClass('real-sortable-initialized');

                sortable.find('thead th').off('click touchend', thClick);
            });
        }

    };

})(jQuery, real);
